import React, { Component,Suspense } from 'react';
import './App.scss';
import ApprovalList from "./components/approval-list/ApprovalList";
import ApprovalDetails from './components/approval-details/ApprovalDetails';
import AgreementDetails from './components/agreement-details/AgreementDetails';
import { HashRouter as Router,Route, Switch} from 'react-router-dom';
import Wait from '@react/react-spectrum/Wait';
import Footer from './components/Footer/Footer';
import ToastInfo from "./components/Common/ToastInfo";
import Header from './components/Header/Header';
import {loadConfig} from "./actions/AppActions";
import {connect} from "react-redux";
import AppBumperComponent from './components/app-bumper/AppBumperComponent';

class App extends Component {
  render() {
      const divStyle = {
          minHeight:(window.innerHeight-94)+'px'
      };

      const divAppBumperStyle = {
          minHeight:(window.innerHeight-111)+'px'
      };

      const Loader = () => (
          <div style={divStyle}>
              <Wait centered size="L"/>
          </div>
      );


      return (
        <Suspense fallback={<Loader />}>
            { (this.props.applicationConfig.name) ? (<Header />) :'' }
            <ToastInfo />
            {(this.props.isSignIn) ? (
                (this.props.isSystemUp) ? (
                    <div style={divStyle}>
                        <Router basename={process.env.PUBLIC_URL}>
                          <Switch>
                            <Route exact path="/" component={ApprovalList} />
                            <Route path="/request/:approvalId" component={ApprovalDetails} />
                            <Route path="/agreements" component={AgreementDetails} />
                            </Switch>
                        </Router>
                    </div>
                ) : (<div style={divAppBumperStyle}><AppBumperComponent /></div>)

            ) :(<Loader />)}
           <Footer />
        </Suspense>
    );
  }

    componentDidMount(){
        this.props.loadConfig();
    }
}

const mapStateToProps = (state)=>{
    return{
        isSignIn:state.AuthReducer.isSignIn,
        applicationConfig : state.AppReducer.applicationConfig,
        isSystemUp:!state.AppReducer.applicationConfig.is_system_under_maintance,
    }
};


const mapDispatchToProps = (dispatch)=>{
    return{
        loadConfig:() => {dispatch(loadConfig())}
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(App);
